import React, { useState } from 'react';
import {
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Icon,
  Grid,
} from '@mui/material';
import ReusableTooltip from '../common/Tooltip/Tooltip';
import useStyles from './styles';
import AppBar from '../AppBar/AppBar';
import { useSidebarContext } from '../../context/sidebarContext';

export default function Header(props) {
  const { sidebarOpen } = useSidebarContext();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const referrerDomain = localStorage.getItem('referrerDomain');

  // switch handler
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleLogout = () => {
    handleClose();
    localStorage.clear();
    if (referrerDomain === '') {
      window.location.href = process.env.REACT_APP_FH_STAGGING_BASE_URL;
    } else {
      // console.log('local ip');
      const url = new URL(referrerDomain);
      const protocolAndDomain = `${url.protocol}//${url.hostname}`; // Includes http/https and domain
      window.location.href = protocolAndDomain;
    }
  };

  return (
    <AppBar
      position="fixed"
      className={sidebarOpen ? classes.appBarOpen : classes.appBarClosed}
    >
      <Grid container alignItems="center">
        <Grid item xs={3}></Grid>
        <Grid item xs={6} textAlign="center">
          <Typography className={classes.headertext}>
            {props.headertext}
          </Typography>
        </Grid>
        <Grid item xs={3}>
          <Grid
            container
            justifyContent={'end'}
            item
            
          >
            <Grid item xs={2} sm={2}>
              <ReusableTooltip title="Account settings">
                <IconButton
                  onClick={handleClick}
                  className={classes.userProfile}
                  aria-controls={open ? 'account-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? 'true' : undefined}
                >
                  <Icon className="fh-icon fh-icon-user" sx={{fontSize:'1rem'}}/>
                </IconButton>
              </ReusableTooltip>
              <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                // onClick={handleClose}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    background:
                      localStorage.getItem('theme') === 'light'
                        ? '#FFFFFF'
                        : '#333',
                    overflow: 'visible',
                    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                    mt: 1.5,
                    '& .MuiAvatar-root': {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    '&:before': {
                      content: '""',
                      display: 'block',
                      position: 'absolute',
                      top: 0,
                      right: 14,
                      width: 100,
                      height: 10,
                      transform: 'translateY(-50%) rotate(45deg)',
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
              >
                <MenuItem onClick={handleLogout}>
                  <Icon
                    className="fh-icon fh-icon-logout"
                    onClick={handleLogout}
                  />
                  <Typography variant="body3" onClick={handleLogout}>
                    Logout
                  </Typography>
                </MenuItem>
              </Menu>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </AppBar>
  );
}
